module.exports = __webpack_public_path__ + "static/mstile-310x310-f9dda02312c20977e529feba7c1c092c.png";